import { CloudUpload } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CloudUploadIcon = createLucideIcon(CloudUpload);
